module.exports = __webpack_public_path__ + "img/securitize-id-logo.28f638a3.svg";